export const uploadConfig = {
    MAX_NUMBER_OF_PHOTOS:75,
    MAX_SIZE_OF_PHOTO:20971520, // 20MB
    // MAX_SIZE_OF_PHOTO:10485760, // 10MB
    VENDORS_MAX_NUMBER_OF_PHOTOS: 15,
}